import React, { useState } from "react";
import { MetricSelection } from "./MetricSelection";
import { Card, CardContent, Typography } from "@mui/material";
import { MetricCharts } from "./MetricCharts";
import { useFetchMetrics } from "../hooks/useFetchMetrics";
import StatsSummary from "./StatsSummary";

export const FruitifyMetrics = ({ school = null }) => {
  const [subscriptionCategory, setSubscriptionCategory] = useState("ALL");
  const {
    metrics,
    metricOptions,
    loading,
    error,
    fetchMetricOptions,
    fetchMetrics,
  } = useFetchMetrics(school, subscriptionCategory);

  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography variant={"h3"} sx={{ mb: 3 }}>
          Fruitify Metrics
        </Typography>
        <MetricSelection
          metricOptions={metricOptions}
          fetchMetrics={fetchMetrics}
          fetchMetricOptions={fetchMetricOptions}
          schoolView={!!school}
          subscriptionCategory={subscriptionCategory}
          setSubscriptionCategory={setSubscriptionCategory}
        />
        <Typography variant="body2" color="text.secondary" sx={{ my: 2 }}>
          Categories use current school approval. Archived records are excluded.
          All also includes eligible records without a current subscription.
        </Typography>
        <MetricCharts
          metrics={metrics?.data}
          error={error}
          loading={loading}
          weeklyOnly={metrics?.weeklyOnly}
        />
        {metrics?.stats && (
          <StatsSummary stats={metrics.stats} weeklyOnly={metrics.weeklyOnly} />
        )}
      </CardContent>
    </Card>
  );
};
